<template>
	<div class="flex1" style="height:100%">
		<Title :title="'车辆行驶里程'"></Title>
		<MyEcharts v-if="showcdata" :id="'options24hourswarn'" :options="cdata" />
	</div>
</template>

<script>
	import MyEcharts from '../charts/echarts.vue'
	import Title from '../title.vue'
	import * as echarts from 'echarts5'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		data() {
			return {
				showcdata: false,
				// title:"车辆新增及活跃趋势",
				cdata: {
					backgroundColor: 'rgba(0, 0, 0, 0.1)',
					xAxis: {
						type: 'category',
						boundaryGap: false,
					},
					yAxis: {
						type: 'value',
						splitLine: false
					},
					series: [{
						name: '行驶里程',
						type: 'line',
						smooth: true,
						lineStyle: {
							width: 2,
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
									offset: 0,
									color: 'RGBA(61, 161, 255, 1)'
								},
								{
									offset: 1,
									color: 'RGBA(52, 41, 240, 1)'
								}])
						},
						areaStyle: {
							opacity: 0.8,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(101, 97, 240, 0.42)'
							},
							{
								offset: 1,
								color: 'rgba(118, 206, 255, 0)'
							}])
						},
					}]
				}
			};
		},
		components: {
			MyEcharts,
			Title
		},
		mounted() {
			this.getBattery24hours()
		},
		methods: {
			//获取24小时电次数分布
			getBattery24hours() {
				let params = {
					"enCode": "per_vehicle-车辆行驶里程",
					"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || 'LDP31B967MG929008'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					if (res) {
						let data = []
						let xAxis = []
						res.forEach(item => {
							xAxis.push(item.cur_date.substr(5, 10))
							data.push(item.drive_mileage)
						})
						this.cdata.xAxis.data = xAxis
						this.cdata.series[0].data = data
						this.showcdata = true
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
@import './comm.scss';
</style>
